import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';

// Pages
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import DashboardPage from './pages/DashboardPage';
import CompaniesPage from './pages/CompaniesPage';
import AssessmentsPage from './pages/AssessmentsPage';
import AssessmentDetailPage from './pages/AssessmentDetailPage';
import ReportsPage from './pages/ReportsPage';
import ReportDetailPage from './pages/ReportDetailPage';
import GenerateReportPage from './pages/GenerateReportPage';
import PricingPage from './pages/PricingPage';
import AdminPage from './pages/AdminPage';
import SettingsPage from './pages/SettingsPage';
import PaymentCallbackPage from './pages/PaymentCallbackPage';
import InvoicesPage from './pages/InvoicesPage';

import './App.css';

// Remove Emergent badge
(function removeBadge() {
  const remove = () => {
    const el = document.getElementById('emergent-badge');
    if (el) el.parentNode.removeChild(el);
    document.querySelectorAll('a[href*="emergent-badge"], a[href*="utm_source=emergent"]').forEach(e => e.parentNode.removeChild(e));
  };
  remove();
  setInterval(remove, 200);
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(remove).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ForgotPasswordPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/payment/callback" element={<PaymentCallbackPage />} />
              <Route path="/invoices" element={<InvoicesPage />} />
              
              {/* Protected Routes */}
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                } 
              />
              
              <Route 
                path="/companies" 
                element={
                  <ProtectedRoute>
                    <CompaniesPage />
                  </ProtectedRoute>
                } 
              />
              
              <Route 
                path="/companies/new" 
                element={
                  <ProtectedRoute>
                    <CompaniesPage />
                  </ProtectedRoute>
                } 
              />
              
              <Route 
                path="/assessments" 
                element={
                  <ProtectedRoute>
                    <AssessmentsPage />
                  </ProtectedRoute>
                } 
              />
              
              <Route 
                path="/assessments/new" 
                element={
                  <ProtectedRoute>
                    <AssessmentsPage />
                  </ProtectedRoute>
                } 
              />
              
              <Route 
                path="/assessments/:id" 
                element={
                  <ProtectedRoute>
                    <AssessmentDetailPage />
                  </ProtectedRoute>
                } 
              />
              
              <Route 
                path="/reports" 
                element={
                  <ProtectedRoute>
                    <ReportsPage />
                  </ProtectedRoute>
                } 
              />
              
              <Route 
                path="/reports/:id" 
                element={
                  <ProtectedRoute>
                    <ReportDetailPage />
                  </ProtectedRoute>
                } 
              />
              
              <Route 
                path="/reports/generate/:assessmentId" 
                element={
                  <ProtectedRoute>
                    <GenerateReportPage />
                  </ProtectedRoute>
                } 
              />
              
              <Route 
                path="/settings" 
                element={
                  <ProtectedRoute>
                    <SettingsPage />
                  </ProtectedRoute>
                } 
              />
              
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute>
                    <AdminPage />
                  </ProtectedRoute>
                } 
              />
              
              {/* Catch all - redirect to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
